<svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M11.8802 13.2693V11.8804C11.8802 11.1437 11.5875 10.4371 11.0666 9.91621C10.5456 9.39528 9.83909 9.10262 9.10238 9.10262H3.54682C2.81011 9.10262 2.10357 9.39528 1.58264 9.91621C1.0617 10.4371 0.769043 11.1437 0.769043 11.8804V13.2693M9.10238 3.54706C9.10238 5.08119 7.85872 6.32484 6.3246 6.32484C4.79047 6.32484 3.54682 5.08119 3.54682 3.54706C3.54682 2.01294 4.79047 0.769287 6.3246 0.769287C7.85872 0.769287 9.10238 2.01294 9.10238 3.54706Z"
    stroke="currentColor"
    stroke-width="1.53846"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
